(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-registration/assets/react/init.js') >= 0) return;  svs.modules.push('/modules/player-registration/assets/react/init.js');
'use strict';

const {
  PlayerRegistrationApp
} = svs.playerRegistration;
svs.playerRegistration.init = () => {
  ReactDOM.render(React.createElement(PlayerRegistrationApp, null), document.getElementById('react-container-registration'));
};
svs.playerRegistration.init();

 })(window);